import { useI18n } from '@ecom/i18n';
import { Badge, type BadgeTone } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

import { PAYMENT_BUCKET_LABEL_KEY, type PaymentBucket } from '../types';

const TONE: Record<PaymentBucket, BadgeTone> = {
  pending: 'warn',
  confirmed: 'good',
  failed: 'critical',
  refunded: 'neutral',
  cancelled: 'neutral',
};

export function PaymentBucketBadge({ bucket }: { bucket: PaymentBucket }): ReactElement {
  const { t } = useI18n();
  return <Badge tone={TONE[bucket]}>{t(PAYMENT_BUCKET_LABEL_KEY[bucket])}</Badge>;
}
